import { useEffect, useState } from 'react'
import { Table, Space, Button, Col, Row, Modal, Divider, Checkbox, Pagination } from 'antd'
import { ExclamationCircleOutlined } from '@ant-design/icons'
import { observer } from 'mobx-react-lite'
import { useStore } from '../../hooks'
import { DATE_TIME_FORMAT_CLIENT, getPage, PAGE_SIZE } from '../../helpers/constants'
import { GLOBAL_CLIENT } from '../../helpers/GlobalClient'
import { useTranslation } from 'react-i18next'
import Create from './Create'
import moment from 'moment'
import useWindowDimensions from '../../common/useWindowDimensions'
import useModal from 'src/helpers/modal/useModal'
import { debounce, isEmpty, size, trim } from 'lodash'

const NotificationManagementScreen = observer(() => {
   const { t } = useTranslation()
   const CommonConfigStore = useStore('CommonConfigStore')
   const [textSearch, set_textSearch] = useState('')
   const { height } = useWindowDimensions()

   const [visibleCreate, setVisibleCreate] = useState(false)
   const [sortDateDesc, setSortDateDesc] = useState(true)
   const [visibleDetail, setVisibleDetail] = useState(false)
   const [item, setItem] = useState(null)
   const { rows, offset, count } = CommonConfigStore.notificationList
   const { confirm } = useModal()
   useEffect(() => {
      handle_getListData(0)
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [textSearch, sortDateDesc])

   const handle_getListData = async (currentPage: number) => {
      const offset = getPage(currentPage)
      const params = { offset }
      await CommonConfigStore.getNotificationListAdmin(params)
   }
   const onChange = (currentPage: number) => {
      handle_getListData(currentPage - 1)
   }

   const showCreate = () => {
      // props.history.push(ROUTER_PATH.CreateEmployeeScreen);
      setVisibleCreate(true)
   }

   const handleCreate = async () => {
      setTimeout(() => {
         handle_getListData(0)
      }, 100)
      setVisibleCreate(false)
   }

   const handleCancel = () => {
      setVisibleCreate(false)
   }

   const clearDetailInfo = () => {
      setItem(null)
   }

   const handleEdit = () => {
      handle_getListData(0)
      setVisibleDetail(false)
      clearDetailInfo()
   }

   const hideDetail = () => {
      setVisibleDetail(false)
      clearDetailInfo()
   }
   const setDetailInfo = (value: any) => {
      setItem(value)
   }

   const showDetail = (value: any) => {
      setDetailInfo(JSON.parse(JSON.stringify(value)))
      // console.log('showDetail; ', JSON.parse(JSON.stringify(value)))

      setTimeout(() => {
         setVisibleDetail(true)
      }, 500)
   }

   //   const onChangeStatus = async (item: any, e: any, index: number) => {
   //       console.log('val; ', e.target.checked)

   //       const result = await CommonConfigStore.updateHighlightNotification(e.target.checked, item?.id)
   //       if (result) {
   //          handle_getListData(0)
   //          // showMessageError('Cập nhật thành công')

   //       } else {

   //       }
   //    }

   const onChangeStatus = debounce((item, checked) => {
      CommonConfigStore.updateHighlightNotification(checked?.target?.checked, item?.id).then((result) => {
         if (result) {
            handle_getListData(0)
         }
      })
   }, 300) // delay 300ms

   const columns = [
      {
         title: t(GLOBAL_CLIENT.id),
         dataIndex: 'id',
         key: 'id',
         align: 'center' as 'center',
         width: 60
         // fixed: 'left',
         //  render: (value: string, record: any, index: number) =>
         //      (page-1) * PAGE_SIZE + index + 1,
      },
      // {
      //    title: 'Tiêu đề',
      //    dataIndex: 'title',
      //    key: 'title',
      //    width: 120,
      //    render: (value: any) => {
      //       return <span className="txtMax2Line">{value}</span>
      //    }
      // },
      {
         title: 'Nội dung',
         dataIndex: 'description',
         key: 'description',
         width: 120,
         render: (value: any) => {
            return <span className="txtMax2Line">{value}</span>
         }
      },
      {
         title: 'Người nhận',
         dataIndex: 'type',
         key: 'type',
         width: 120,
         render: (value: any) => {
            return (
               <span className="txtMax2Line">{value == '1' ? 'Creator' : value == '2' ? 'Designer' : 'Tất cả'}</span>
            )
         }
      },
      {
         title: 'Active thông báo',
         dataIndex: 'markRead',
         key: 'markRead',
         width: 120,
         render: (value: any, record: any) => {
            return (
               <Checkbox
                  defaultChecked={!record.markRead}
                  className="gx-pointer"
                  onChange={(e) => onChangeStatus(record, e)}
               >
                  Active
               </Checkbox>
            )
         }
      },
      {
         title: t(GLOBAL_CLIENT.createAt),
         dataIndex: 'updatedAt',
         key: 'updatedAt',
         width: 80,
         render: (value: string) => {
            return <span className="txtMax2Line">{moment(value).format(DATE_TIME_FORMAT_CLIENT)}</span>
         }
         // sorter: {
         //    compare: (a: any, b: any) =>
         //       parseFloat(moment(a.createdAt).format('YYYYMMDDHHmmss')) -
         //       parseFloat(moment(b.createdAt).format('YYYYMMDDHHmmss')),
         //    multiple: 3
         // },
         // defaultSortOrder: 'descend' as 'descend'
      },
      {
         title: 'Action',
         key: 'action',
         dataIndex: 'updatedAt',
         width: 80,
         align: 'center' as 'center',
         fixed: 'right' as 'right',
         render: (text: string, record: any) => {
            return (
               <span className="txtMax2Line">
                  <span onClick={() => showDetail(record)} className="gx-link">
                     {'Chi tiết'}
                  </span>
               </span>
            )
         }
      }
   ]

   const renderPagination = () => {
      if (isEmpty(rows)) {
         return null
      }

      return (
         <div className="containerPagination">
            <Pagination
               onChange={onChange}
               pageSize={PAGE_SIZE}
               current={offset / PAGE_SIZE + 1}
               showSizeChanger={false}
               total={count}
            />
         </div>
      )
   }

   return (
      <>
         <Row>
            <Col span={24}>
               <Row className="row-container-head">
                  <Col xs={24} md={12}>
                     {/* <Input.Search
                                onSearch={handleChangeTextSearch}
                                placeholder={t(GLOBAL_CLIENT.txtSearch)}
                                allowClear
                            /> */}
                  </Col>
                  <Col xs={24} md={12}>
                     <div className="text-right">
                        <Space>
                           {/* {renderFilter()} */}
                           <Button type="primary" className="btn-add" onClick={showCreate}>
                              <i className="icon icon-add icon-in-button" />
                              {t(GLOBAL_CLIENT.create)}
                           </Button>
                        </Space>
                     </div>
                  </Col>
               </Row>

               <Space className="total-items">
                  {t(GLOBAL_CLIENT.totalItems)}: {count}
               </Space>

               <Table
                  // scroll={{ x: 1200 }}
                  scroll={{ y: height - 280 }}
                  columns={columns}
                  dataSource={rows}
                  rowKey="id"
                  pagination={false}
               />

               {renderPagination()}
            </Col>
         </Row>
         {visibleCreate && <Create visible={visibleCreate} onOk={handleCreate} onCancel={handleCancel} />}
         {visibleDetail && item && (
            <Create visible={visibleDetail} item={item} onOk={handleEdit} onCancel={hideDetail} />
         )}
      </>
   )
})

export default NotificationManagementScreen
